import { Carousel } from 'bootstrap';

document.addEventListener('DOMContentLoaded', () => {
  const carouselElement = document.querySelector('#locationCarousel');
  const carousel = new Carousel(carouselElement, {
    keyboard: false, // Disable keyboard navigation
    interval: false, // Disable automatic cycling
    wrap: false      // Disable wrap-around
  });

  const items = document.querySelectorAll('#locationCarousel .carousel-item');
  const firstIndex = Array.from(items).indexOf(document.querySelector('#locationCarousel .carousel-item.first'));
  const lastIndex = Array.from(items).indexOf(document.querySelector('#locationCarousel .carousel-item.last'));
  const lastIndexOffset = lastIndex - 3;

  const prevButton = document.querySelector('#locationCarousel .carousel-control-prev');
  const nextButton = document.querySelector('#locationCarousel .carousel-control-next');

  const updateControls = () => {
    const activeIndex = Array.from(items).indexOf(document.querySelector('#locationCarousel .carousel-item.active'));
    prevButton.style.visibility = activeIndex <= firstIndex ? 'hidden' : 'visible';
    nextButton.style.visibility = (lastIndex - activeIndex) < 4 ? 'hidden' : 'visible';
  };

  // Override the previous button click
  prevButton.addEventListener('click', function (e) {
    e.preventDefault();
    movePrev();
    updateControls();
  });

  // Override the next button click
  nextButton.addEventListener('click', function (e) {
    e.preventDefault();
    moveNext();
    updateControls();
  });

  let startX;
  let endX;
  let allowNextSwipe = true;

  carouselElement.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
  });

  carouselElement.addEventListener('touchmove', (e) => {
    endX = e.touches[0].clientX;
    const activeIndex = Array.from(items).indexOf(document.querySelector('#locationCarousel .carousel-item.active'));

    allowNextSwipe = !(startX - endX > 50 && activeIndex >= lastIndexOffset - 1);
  });

  carouselElement.addEventListener('touchend', (e) => {
    if (!allowNextSwipe) {
      e.preventDefault();
    } else {
      const threshold = 50; // Minimum swipe distance
      const activeIndex = Array.from(items).indexOf(document.querySelector('#locationCarousel .carousel-item.active'));

      if (startX - endX > threshold && activeIndex < lastIndexOffset) {
        moveNext(activeIndex);
      } else if (endX - startX > threshold && activeIndex > firstIndex) {
        movePrev(activeIndex);
      }

      startX = null;
      endX = null;
    }
  });

  carouselElement.addEventListener('slid.bs.carousel', updateControls);

  const getFocusableElements = (element) => {
    return element.querySelectorAll('a, button, input, [tabindex]:not([tabindex="-1"])');
  };

  const moveNext = (activeIndex) => {
    activeIndex ??= Array.from(items).indexOf(document.querySelector('#locationCarousel .carousel-item.active'));
    if (activeIndex < (lastIndex - 3)) {
      carousel.to(activeIndex + 4);
    }
  };

  const movePrev = (activeIndex) => {
    activeIndex ??= Array.from(items).indexOf(document.querySelector('#locationCarousel .carousel-item.active'));
    if (activeIndex >= 3) {
      carousel.to(activeIndex - 4);
    }
  };


  carouselElement.addEventListener('keydown', (event) => {
    const activeItem = document.querySelector('#locationCarousel .carousel-item.active');
    const activeIndex = Array.from(items).indexOf(activeItem);

    const focusableElements = getFocusableElements(activeItem);
    const focusableArray = Array.from(focusableElements);
    const currentFocusIndex = focusableArray.indexOf(document.activeElement);

    let nextIndex = activeIndex + 3;
    if (nextIndex > lastIndex)
      nextIndex = activeIndex + 2;
    if (nextIndex > lastIndex)
      nextIndex = activeIndex + 1;
    if (nextIndex > lastIndex)
      nextIndex = activeIndex;

    const nextItem = items[nextIndex];
    const nextFocusableElements = getFocusableElements(nextItem);
    const nextArray = Array.from(nextFocusableElements);
    const nextFocusIndex = nextArray.indexOf(document.activeElement);

    const allFocusable = getFocusableElements(document.querySelector('#locationCarousel'));
    const allFocusableArray = Array.from(allFocusable);
    const allFocusIndex = allFocusableArray.indexOf(document.activeElement);
    const focusTimeout = 500;

    switch (event.key) {
      case 'Tab':
        if (!event.shiftKey) {
          if (nextFocusIndex === nextArray.length - 1) {
            if (nextIndex < lastIndex) {
              event.preventDefault();
              moveNext(activeIndex);//carousel.next();
              setTimeout(function () {
                const nextElement = allFocusable[allFocusIndex + 1] || allFocusable[0];
                nextElement.focus();
              }, focusTimeout);
            }
          }
        } else {
          if (currentFocusIndex === 0) {
            if (activeIndex > firstIndex) {
              event.preventDefault();
              movePrev(activeIndex);//carousel.prev();
              setTimeout(function () {
                const prevElement = allFocusable[allFocusIndex - 1] || allFocusable[0];
                prevElement.focus();
              }, focusTimeout);
            }
          }
        }
        break;
      case 'ArrowRight':
        if (nextFocusIndex === nextArray.length - 1) {
          if (nextIndex < lastIndex) {
            event.preventDefault();
            moveNext(activeIndex);//carousel.next();
            setTimeout(function () {
              const nextElement = allFocusable[allFocusIndex + 1] || allFocusable[0];
              nextElement.focus();
            }, focusTimeout);
          }
        }
        else if (allFocusIndex > -1) {
          const nextElement = allFocusable[allFocusIndex + 1] || allFocusable[0];
          nextElement.focus();
        }
        break;
      case 'ArrowLeft':
        if (currentFocusIndex === 0) {
          if (activeIndex > firstIndex) {
            event.preventDefault();
            movePrev(activeIndex);//carousel.prev();
            setTimeout(function () {
              const prevElement = allFocusable[allFocusIndex - 1] || allFocusable[0];
              prevElement.focus();
            }, focusTimeout);
          }
        }
        else if (allFocusIndex > -1) {
          const prevElement = allFocusable[allFocusIndex - 1] || allFocusable[0];
          prevElement.focus();
        }
        break;
      default:
        break;
    }
  });

  document.querySelectorAll('.carousel-item a').forEach(function (anchor) {
    anchor.addEventListener('focus', function (event) {
      const itemsArray = Array.from(items);
      const activeIndex = itemsArray.indexOf(this.closest('.carousel-item'));
      const currentIndex = itemsArray.findIndex(item => item.classList.contains('active'));

      if (Math.abs(currentIndex - activeIndex) > 3) {
        event.preventDefault();

        itemsArray.forEach(item => item.classList.remove('active'));
        itemsArray[0].classList.add('active');
        itemsArray[0].querySelector('a').focus();
      }
    });
  });

  updateControls();
});
